import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeScreen from '../pages/HomeScreen.vue';
import TermsOfServiceScreen from '../pages/TermsOfServiceScreen.vue';
import PrivacyPolicyScreen from '../pages/PrivacyPolicyScreen.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeScreen',
    component: HomeScreen
  },
  {
    path: '/terms-of-service',
    name: 'TermsOfServiceScreen',
    component: TermsOfServiceScreen
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicyScreen',
    component: PrivacyPolicyScreen
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
